var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-main-container"},[_c('div',{staticClass:"bread-crumb-container"},[_c('Breadcrumb')],1),_c('section',{staticClass:"app-main"},[_c('div',{staticClass:"app-container"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view',{key:_vm.key,ref:"rv"})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }